var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import { H5 } from 'syf-component-library/ui/typography';
import { Stack } from 'syf-component-library/ui/spacing';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import i18n, { t } from '../../../../strings/i18n/i18n';
import { fontSizes, fontWeights, lineHeights, spacing } from 'syf-component-library/defaultTheme';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import { shallowEqual, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import OnlineChatLink from '../../../../ui/atoms/OnlineChatLink';
import LaunchPointName from '../../../../const/launchPointName';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
var HeaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 ", "px 64px ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 ", "px 64px ", "px;\n"])), spacing.large, spacing.large);
var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", "px 0 ", "px 0;\n"], ["\n  margin: ", "px 0 ", "px 0;\n"])), spacing.xxlarge, spacing.large);
var BoldTitle = styled(H5)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: 28px;\n  text-align: center;\n  margin-bottom: ", "px;\n"], ["\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: 28px;\n  text-align: center;\n  margin-bottom: ", "px;\n"])), fontWeights.bold, fontSizes.medium, spacing.small);
var Title = styled(H5)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: ", ";\n  text-align: center;\n  font-weight: normal;\n"], ["\n  font-size: ", "px;\n  line-height: ", ";\n  text-align: center;\n  font-weight: normal;\n"])), fontSizes.root, lineHeights.root);
var RedisputeNotEligible = function () {
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var _a = useSelector(function (state) { return state; }, shallowEqual), accountId = _a.appConfig.accountId, assetsURL = _a.mfeConfig.assetsURL;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    useEffect(function () {
        triggerAnalyticsEvent({
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Redispute,
            pageName: Analytics.NotEligible,
            errorMessage: t('questionnaire.notEligible')
        });
    }, []);
    /* istanbul ignore next */
    var handleLaunchChat = function () {
        pointOfNeedChat(LaunchPointName.Disputes, accountId);
    };
    return (_jsxs(HeaderContainer, __assign({ "data-cy": "redispute-ineligible-modal" }, { children: [_jsx(ImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "WARNING", size: imageSize }) }), _jsx(Stack, { size: "medium" }), _jsx(BoldTitle, { children: t('questionnaire.notEligible') }), _jsx(Title, { children: _jsx(Trans, { i18n: i18n, i18nKey: "questionnaire.pleaseTryAgain", components: [
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": Analytics.OnlineChat, "data-title": "transaction-enrichment", "data-type": "transaction-enrichment", onClick: handleLaunchChat }, "online chat")
                    ] }) })] })));
};
export default RedisputeNotEligible;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map